import styled from '@emotion/styled';
import Button from '@shared/components/core/button/CoreButton';
import { ButtonRow } from '@shared/components/core/card/CommonCardStyles';
import TextInputWithAdornment from '@shared/components/core/field/TextInputWithAdornment';
import { obscureString } from '@shared/hooks/helpers/ObscureText';
import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ClientDelete from '../ClientDelete';
import ClientRotateSecret from '../ClientRotateSecret';

interface IClientKeyEditorProps {
    organizationId: string;
    clientId?: string;
}

export default function ClientKeyEditor({ clientId, organizationId }: IClientKeyEditorProps) {
    const { t } = useTranslation();
    const [showKey, setShowKey] = useState(false);
    const alertsContainer = AlertsContainer.useContainer();

    if (!clientId) return null;

    const handleKeyViewToggle = () => {
        setShowKey(!showKey);
    };

    const copyKey = () => {
        navigator.clipboard.writeText(clientId).then(() => {
            alertsContainer.showSuccess(t('common:profile.share.copied'));
        });
    };

    return (
        <Content>
            <TextInputWithAdornment
                value={showKey ? clientId : obscureString(clientId)}
                readOnly
                onClick={copyKey}
                inputLabel={t('common:organization.projects.key.title')}
                actionLabel={t('common:organization.projects.key.copy')}
            />
            <ButtonRow>
                <Button $color="accent" startIcon="eye" onClick={handleKeyViewToggle}>
                    {t('common:organization.projects.key.view')}
                </Button>
                <ClientRotateSecret organizationId={organizationId} clientId={clientId} />
                <ClientDelete organizationId={organizationId} clientId={clientId} />
            </ButtonRow>
        </Content>
    );
}

const Content = styled.div`
    display: flex;
    flex-direction: column;
`;
